import * as z from "zod";

/**
 * Invoice data returned after an order edit that results in a price change
 */
const InvoiceDataSchema_ = z.object({
  /** Order total price before the edit */
  totalPriceBefore: z.string(),
  /** Order total price after the edit */
  totalPriceAfter: z.string(),
  /** Currency code (e.g., 'USD', 'EUR') */
  currency: z.string(),
  /** Amount difference (positive = customer owes, negative = refund) */
  amountDifference: z.number(),
  /** Shop currency code, which the shop amounts below use */
  shopCurrency: z.string(),
  /** Signed order total change in shop currency */
  shopAmountDifference: z.number(),
  /** Signed change in what the shopper pays for Redo products, in shop currency */
  redoProductsDifference: z.number(),
  /** Shopify payment collection URL (only present when customer owes money) */
  invoiceUrl: z.string().optional(),
});

export const InvoiceDataSchema: z.ZodType<InvoiceData> = InvoiceDataSchema_;
export interface InvoiceData extends z.infer<typeof InvoiceDataSchema_> {}
